<template>
  <div>
    <h2>Support</h2>
    <label>
      Email: <input type="input" v-model="supportEmail" size="50">
    </label>
    <div class="hint">
      Support requests will be sent to this email. Also, it's added as reply to address for notification emails.
    </div>
    <br>
    <button @click="cancel()">Cancel</button>
    <button @click="saveSupportSettings()">Save</button>

    <h2>Notifications</h2>
    <table>
      <tr>
        <td valign="top">Enabled:</td>
        <td>
          <label class="switch">
            <input type="checkbox" v-model="notifications">
            <span class="slider round"></span>
          </label>
        </td>
      </tr>
      <tr>
        <td valign="top">Emails:</td>
        <td>
          <div v-for="(email, index) in notificationEmails" :key="index">
            <input type="input" v-model="email.value" size="50">
          </div>
          <button @click="newNotificationEmail">Add</button>
        </td>
      </tr>
    </table>
    <button @click="cancel()">Cancel</button>
    <button @click="saveNotificationSettings()">Save</button>

    <pre class="debug" v-show="debugMode">{{ settings }}</pre>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hint {
  font-size: small;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  name: 'settingsPartner',
  data () {
    return {
      supportEmail: null,
      notifications: null,
      notificationEmails: []
    }
  },
  mounted () {
    this.init()
  },
  watch: {
    settings () {
      this.init()
    }
  },
  computed: {
    ...mapState([
      'partnerMode',
      'accountMode',
      'debugMode',
      'account',
      'settings'
    ])
  },
  methods: {
    init () {
      this.supportEmail = this.settings.support_email
      this.notifications = this.settings.notifications
      this.initNotificationEmails()
    },
    initNotificationEmails () {
      this.notificationEmails = []
      for (var email in this.settings.notification_emails) {
        this.notificationEmails.push({value: this.settings.notification_emails[email]})
      }
    },
    getNotificationEmails () {
      var emails = []
      for (var email in this.notificationEmails) {
        if (this.notificationEmails[email].value)
          emails.push(this.notificationEmails[email].value)
      }
      return emails
    },
    newNotificationEmail () {
      this.notificationEmails.push({value: ''})
    },
    refreshSettings () {
      this.$store.dispatch('loadSettings')
    },
    cancel () {
      this.$store.dispatch('loadSettings')
    },
    saveSupportSettings () {
      var params = {
        support_email: this.supportEmail
      }
      this.$store.dispatch('saveSettings', params)
    },
    saveNotificationSettings () {
      var params = {
        notifications: this.notifications,
        notification_emails: this.getNotificationEmails()
      }
      this.$store.dispatch('saveSettings', params)
    }
  }
}
</script>
